export default "__VITE_ASSET__CBiYLDRG__"